const notEmptyArray = (arr) => Array.isArray(arr) && arr.length > 0;

export default notEmptyArray;
